import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AirbusAssetListComponent from '../../../Components/AirbusAssetComponent/AirbusAssetListComponent';

const AirbusAssetList = (props) => {
    let navigate = useNavigate();
    const params = useParams();

    return (
        <div>
            <AirbusAssetListComponent {...props} navigate={navigate} id={params.id} />
        </div>
    );
}

export default AirbusAssetList